import React, { Component } from 'react';
import './wrapper-total-length-percen-chart.style.css'
import ComposeChartTest from '../../composechart.component'
import LineChartTest from '../../linechart.component'



class WrapperTotalLengthPercentChart extends Component {
    render() {
        return (
            <div className="wrapper-total-length-percent-chart grid-container--fit">
                {/* <div className="chart-total-length"></div>
                <div className="chart-nrw-percent"></div> */}
                <div className="grid-element">
                    <h1 className="name-element-dashboard">TOTAL LENGTH BY DMA</h1>
                    <h2 className="description-element-dashboard">June 2020</h2>
                    <ComposeChartTest></ComposeChartTest>
                </div>
                <div className="grid-element">
                    <h1 className="name-element-dashboard">PERCENT NRW</h1>
                    <h2 className="description-element-dashboard">Per session</h2>
                    <LineChartTest></LineChartTest>
                </div>
            </div>
        )
    }
}

export default WrapperTotalLengthPercentChart;
